import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {RuleEditorTriggerGroupsEnum} from '../ruleTriggerModel';
import {StyledDropdownGroupTitleWrapper} from './ruleEditorCommons';

/*
 * Types.
 */

interface RuleTriggerGroupTitleProps {
  id: RuleEditorTriggerGroupsEnum;
}

/*
 * Component.
 */

export const RuleTriggerGroupTitle: FC<RuleTriggerGroupTitleProps> = ({id}) => (
  <StyledDropdownGroupTitleWrapper>{getTitle(id)}</StyledDropdownGroupTitleWrapper>
);

/*
 * Helpers.
 */

const getTitle = (id: RuleEditorTriggerGroupsEnum) => {
  switch (id) {
    case RuleEditorTriggerGroupsEnum.MESSAGE:
      return <Trans id="rule-editor-trigger-group-message">Message</Trans>;

    case RuleEditorTriggerGroupsEnum.STATUS:
      return <Trans id="rule-editor-trigger-group-status">Status</Trans>;

    case RuleEditorTriggerGroupsEnum.TEAMMATE:
      return <Trans id="rule-editor-trigger-group-teammate">Teammates</Trans>;

    case RuleEditorTriggerGroupsEnum.TAG:
      return <Trans id="rule-editor-trigger-group-tag">Tags</Trans>;

    case RuleEditorTriggerGroupsEnum.TOPIC:
      return <Trans id="rule-editor-trigger-group-topic">Links</Trans>;

    default:
      return id;
  }
};
